export const toastStyles = {
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,

  style: {
    backgroundColor: 'white ',
    color: 'black',
    fontSize: '16px',
    padding: '10px',
    fontFamily: 'Poppins, sans-serif',
    borderRadius: '8px',
  },
  theme: 'colored',
};

export const toastContainerStyles = {
  position: 'bottom-center',
  padding: '10px',
  color: 'white',
  fontFamily: 'Poppins, sans-serif',
  borderRadius: '8px',
};
